module.exports = __webpack_public_path__ + "img/IMG_7189_L_Black_MockedUp.b39ec79f.jpg";